import React, {useCallback, useState} from 'react';
import {useLiveViewContext} from "../LiveViewProvider";
import { mapToMomentFormat} from "../../../../utils/helper";
import ENUMS from "../../../../utils/ENUMS";
import axios from "axios";
import { toast } from 'react-toastify';
import {BASE_URL} from '../../../../config.json'


const TabularLiveViewMeta = () => {

    const {state, setState} = useLiveViewContext()
    const {courseData, playersLiveData, courseList} = state
    const {course_name = ''} = courseData || {}
    const [dropdown, setDropdown] = useState(false);
    const token = localStorage.getItem(ENUMS.AUTH);


    const exportCSV=()=>{
        let courses = JSON.parse(localStorage.getItem("courses"))

        if(!courses?.length) return toast.error("No courses available!")

        const courseId= courses[0].id
        axios({
            url: `${BASE_URL}/club/live_view/download/${courseData.id}`, //your url
            headers: { Authorization: `Bearer ${token}`},
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'CourseData.xls'); //or any other extension
            document.body.appendChild(link);
            link.click();
        });
      }
    // console.log(playersLiveData, "courselist");

    const handleSelect = (course) => {
        // selectedCourse = course;
        setDropdown(false)
        setState(_state => ({
            ..._state,
            selectedCourse: course,
            courseData: courseData
        }))
        console.log(course, "players live data");
    }


    const renderCourseListView = useCallback(() => (
        <div className="custom-select-wrapper">
            <div style={{cursor: "pointer"}} className={dropdown ? "custom-select open" : "custom-select"} onClick={() => setDropdown(!dropdown)} >
                <div className="custom-select__trigger">
                    <div style={{cursor: "pointer", color: "white"}} className = "text-jost-sb-19 dropdown-btn">{course_name}</div>
                </div>
                <div className="custom-options">
                    {dropdown && courseList.map(course =>
                        <span className="custom-option" onClick={() => handleSelect(course)} data-value="">{course.course_name}</span>
                    )}
                </div>
            </div>
        </div>
    ), [dropdown])

    const renderExportToCSV = useCallback(() => (
                <button onClick={exportCSV} className="res-btn-lightgrn">Export to CSV</button>
    ), [])


    return (
        
        <div className="content-tabs__content___bar">

            {renderCourseListView()}

            {renderExportToCSV()}

        </div>
    );
};

export default TabularLiveViewMeta;
